import { apiClient } from ".";
import { useMutation } from "@tanstack/react-query";
import { captureException } from "@sentry/react";
import { setStatsigUserId } from "../../utils/statsig";

export const startSignIn = async ({
  personalNumber,
  transactionId,
}: {
  personalNumber: string;
  transactionId: string;
}) => {
  const response = await apiClient({
    url: `/auth/sign-in`,
    method: "POST",
    data: {
      username: personalNumber,
      transactionId,
    },
  });

  void setStatsigUserId(response.data?.customerUuid);

  return response.data;
};

export const useStartSignIn = () =>
  useMutation({
    onError: (error) => {
      captureException(error, {
        tags: {
          operation: "postCustomerSignIn",
          errorType: error.name || "UnknownError",
        },
        extra: {
          apiEndpoint: "/auth/sign-in",
        },
        level: "error",
      });
    },
    mutationFn: ({
      personalNumber,
      transactionId,
    }: {
      personalNumber: string;
      transactionId: string;
    }) => startSignIn({ personalNumber, transactionId }),
  });
